// Channel Type
export const INSTAGRAM = "Instagram";
export const WHATSAPP = "Whatsapp";
export const INSTAGRAM_DM = "Instagram_dm";

// Channel Status
export const CONNECTED = "CONNECTED";
export const DISCONNECTED = "DISCONNECTED";
